export default "__VITE_ASSET__CBOmK0BP__"